import localStorageServices from 'services/application/storage/localStorage';

export default {
	...localStorageServices,
};
